import React from 'react';

function ConfirmResetPassword() {
    return (
        <main className="auth-cover-wrapper" dir="rtl">
            <div className="auth-cover-sidebar-inner">
                <div className="auth-cover-card-wrapper">
                    <div className="auth-cover-card p-sm-5">
                        <div className="wd-50 mb-5">
                            <img src="/assets/images/logo-abbr.png" alt="" className="img-fluid"/>
                        </div>
                        <h2 className="fs-20 fw-bolder mb-4">تایید تغییر رمز <a href="#"
                                                                       className="float-end fs-12 text-primary">تغییر روش</a></h2>
                        <h4 className="fs-13 fw-bold mb-2">لطفا کد ارسالی برای رمز یکبار مصرف را وارد کنید تا حساب کاربری شما تایید شود.</h4>
                        <p className="fs-12 fw-medium text-muted"><span>کد ارسال شده است به</span>
                            <strong> 090000000</strong></p>
                        <form action="index.html" className="w-100 mt-4 pt-2">
                            <div id="otp" className="inputs d-flex flex-row justify-content-center mt-2">
                                <input className="m-2 text-center form-control rounded" type="text" id="first"
                                       maxLength="1" required/>
                                <input className="m-2 text-center form-control rounded" type="text" id="second"
                                       maxLength="1" required/>
                                <input className="m-2 text-center form-control rounded" type="text" id="third"
                                       maxLength="1" required/>
                                <input className="m-2 text-center form-control rounded" type="text" id="fourth"
                                       maxLength="1" required/>
                                <input className="m-2 text-center form-control rounded" type="text" id="fifth"
                                       maxLength="1" required/>
                                <input className="m-2 text-center form-control rounded" type="text" id="sixth"
                                       maxLength="1" required/>
                            </div>
                            <div className="mt-5">
                                <button type="submit" className="btn btn-lg btn-primary w-100">تایید</button>
                            </div>
                            <div className="mt-5 text-muted text-center">
                                <span>کد دریافت نکردید؟</span>
                                <a href="#"> ارسال مجدد (1/3)</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="auth-cover-content-inner">
                <div className="auth-cover-content-wrapper">
                    <div className="auth-img">
                        <img src="/assets/images/auth/auth-cover-verify-bg.svg" alt="" className="img-fluid"/>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default ConfirmResetPassword;